import { NeutralColor } from "node-library/dist/colors";

interface IconProps {
	size?: number;
	strokeColor?: string;
	fillColor?: string;
}

function SidebarOrderIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;

	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_950;
	const fillColor = props.fillColor || "transparent";

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.1159 8.32009C14.2109 8.43409 14.3516 8.5 14.5 8.5H16.8C17.3683 8.5 17.7645 8.50039 18.0729 8.52559C18.3755 8.55031 18.5493 8.5964 18.681 8.66349C18.9632 8.8073 19.1927 9.03677 19.3365 9.31901C19.4036 9.45069 19.4497 9.62454 19.4744 9.92712C19.4996 10.2355 19.5 10.6317 19.5 11.2V13.8C19.5 14.3683 19.4996 14.7645 19.4744 15.0729C19.4497 15.3755 19.4036 15.5493 19.3365 15.681C19.1927 15.9632 18.9632 16.1927 18.681 16.3365C18.5493 16.4036 18.3755 16.4497 18.0729 16.4744C17.7645 16.4996 17.3683 16.5 16.8 16.5H9.2C8.6317 16.5 8.23554 16.4996 7.92712 16.4744C7.62454 16.4497 7.45069 16.4036 7.31901 16.3365C7.03677 16.1927 6.8073 15.9632 6.66349 15.681C6.5964 15.5493 6.55031 15.3755 6.52559 15.0729C6.50039 14.7645 6.5 14.3683 6.5 13.8V8.2C6.5 7.6317 6.50039 7.23554 6.52559 6.92712C6.55031 6.62454 6.5964 6.45069 6.66349 6.31901C6.8073 6.03677 7.03677 5.8073 7.31901 5.66349C7.45069 5.5964 7.62454 5.55031 7.92712 5.52559C8.23554 5.50039 8.6317 5.5 9.2 5.5H10.5012C11.0792 5.5 11.2764 5.50402 11.453 5.55151C11.6226 5.59714 11.7829 5.67222 11.9265 5.77332C12.076 5.87852 12.2054 6.02748 12.5754 6.4715L14.1159 8.32009Z"
				fill={fillColor}
				stroke={strokeColor}
				strokeLinejoin="round"
			/>
			<path
				d="M17 16V17.6C17 18.4401 17 18.8601 16.8365 19.181C16.6927 19.4632 16.4632 19.6927 16.181 19.8365C15.8601 20 15.4401 20 14.6 20H5.4C4.55992 20 4.13988 20 3.81901 19.8365C3.53677 19.6927 3.3073 19.4632 3.16349 19.181C3 18.8601 3 18.4401 3 17.6V10.4C3 9.55992 3 9.13988 3.16349 8.81901C3.3073 8.53677 3.53677 8.3073 3.81901 8.16349C4.13988 8 4.55992 8 5.4 8H7"
				stroke={strokeColor}
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function SidebarProfileIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;

	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_950;
	const fillColor = props.fillColor || "transparent";

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				cx="12"
				cy="9.59961"
				r="3.5"
				stroke={strokeColor}
				fill={fillColor}
				strokeLinecap="round"
			/>
			<path
				d="M21.5 11.998C21.5 17.2448 17.2467 21.498 12 21.498C6.75329 21.498 2.5 17.2448 2.5 11.998C2.5 6.75134 6.75329 2.49805 12 2.49805C17.2467 2.49805 21.5 6.75134 21.5 11.998Z"
				stroke={strokeColor}
			/>
			<mask id="path-3-inside-1_1900_3047" fill="white">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.61816 18.744C5.58296 15.8016 8.49468 13.998 11.6245 13.998H12.0001H12.3757C15.5055 13.998 18.4173 15.8016 19.382 18.744C17.5536 20.7438 14.9233 21.998 12.0001 21.998C9.0769 21.998 6.44664 20.7438 4.61816 18.744Z"
				/>
			</mask>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.61816 18.744C5.58296 15.8016 8.49468 13.998 11.6245 13.998H12.0001H12.3757C15.5055 13.998 18.4173 15.8016 19.382 18.744C17.5536 20.7438 14.9233 21.998 12.0001 21.998C9.0769 21.998 6.44664 20.7438 4.61816 18.744Z"
				fill={fillColor}
			/>
			<path
				d="M4.61816 18.744L3.66794 18.4324L3.4859 18.9876L3.88016 19.4188L4.61816 18.744ZM19.382 18.744L20.1201 19.4188L20.5143 18.9876L20.3323 18.4324L19.382 18.744ZM5.56839 19.0556C6.37694 16.5897 8.85344 14.998 11.6245 14.998V12.998C8.13592 12.998 4.78897 15.0136 3.66794 18.4324L5.56839 19.0556ZM11.6245 14.998H12.0001V12.998H11.6245V14.998ZM12.0001 14.998H12.3757V12.998H12.0001V14.998ZM12.3757 14.998C15.1468 14.998 17.6233 16.5897 18.4318 19.0556L20.3323 18.4324C19.2112 15.0136 15.8643 12.998 12.3757 12.998V14.998ZM18.644 18.0692C16.997 19.8705 14.631 20.998 12.0001 20.998V22.998C15.2157 22.998 18.1101 21.617 20.1201 19.4188L18.644 18.0692ZM12.0001 20.998C9.36924 20.998 7.00317 19.8705 5.35617 18.0692L3.88016 19.4188C5.89011 21.617 8.78455 22.998 12.0001 22.998V20.998Z"
				fill={strokeColor}
				mask="url(#path-3-inside-1_1900_3047)"
			/>
		</svg>
	);
}

function SidebarSignoutIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.2243 3.32815L13.3752 3.12674L13.3947 3.12333C13.9243 3.03064 14.3491 2.95631 14.695 2.92177C15.0485 2.88646 15.3647 2.88712 15.6686 2.97146C16.3667 3.16522 16.9464 3.65229 17.2576 4.30655C17.3931 4.59132 17.4482 4.90269 17.4744 5.25703C17.5 5.6037 17.5 6.03489 17.5 6.57262L17.5 6.59235V13.5462L17.5 13.5636C17.5 14.0394 17.5 14.421 17.4798 14.7287C17.4593 15.043 17.4159 15.3202 17.3092 15.5776C16.9974 16.329 16.3395 16.8818 15.5455 17.0594C15.2737 17.1201 14.9931 17.115 14.68 17.0811C14.3734 17.048 13.9975 16.9822 13.5288 16.9001L13.5117 16.8971L12.2243 16.6718L12.192 16.6662C11.4284 16.5326 10.8097 16.4243 10.3258 16.2763C9.82184 16.122 9.40579 15.9085 9.08592 15.5278C8.76606 15.1471 8.62744 14.7005 8.56241 14.1774C8.49998 13.6753 8.49999 13.0472 8.5 12.272V12.2392V7.76079V7.72798C8.49999 6.95284 8.49998 6.32472 8.56241 5.82256C8.62744 5.29953 8.76606 4.8529 9.08592 4.47219C9.40579 4.09149 9.82184 3.87796 10.3258 3.72374C10.8097 3.57568 11.4284 3.46741 12.192 3.33381L12.2243 3.32815Z"
				stroke="#121212"
			/>
			<path
				d="M2 10L1.57574 9.57574L1.15147 10L1.57574 10.4243L2 10ZM11 10.6C11.3314 10.6 11.6 10.3314 11.6 10C11.6 9.66863 11.3314 9.4 11 9.4V10.6ZM5.57574 5.57574L1.57574 9.57574L2.42426 10.4243L6.42426 6.42426L5.57574 5.57574ZM1.57574 10.4243L5.57574 14.4243L6.42426 13.5757L2.42426 9.57574L1.57574 10.4243ZM2 10.6H11V9.4H2V10.6Z"
				fill="#121212"
			/>
		</svg>
	);
}

function SidebarRosterIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;

	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_950;
	const fillColor = props.fillColor || "transparent";

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M20.9995 19.1935C20.9995 18.8614 20.9738 18.5075 20.9291 18.1432C20.5286 14.8763 17.35 12.8848 14.0587 12.8848H12.5879"
				stroke={strokeColor}
				strokeLinecap="round"
			/>
			<mask id="path-2-inside-1_1902_6245" fill="white">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M13.3986 10.1138C14.1217 9.35849 14.5659 8.33403 14.5659 7.20582C14.5659 6.37192 14.3232 5.59471 13.9046 4.94095C14.1421 4.87511 14.3922 4.83993 14.6506 4.83993C16.1889 4.83993 17.4358 6.08692 17.4358 7.62517C17.4358 9.16341 16.1889 10.4104 14.6506 10.4104C14.2003 10.4104 13.775 10.3036 13.3986 10.1138ZM13.2182 4.12033C12.468 3.42503 11.4637 3 10.3601 3C8.03731 3 6.1543 4.88301 6.1543 7.20582C6.1543 9.52863 8.03731 11.4116 10.3601 11.4116C11.1698 11.4116 11.9261 11.1828 12.5678 10.7863C13.1652 11.1808 13.8811 11.4104 14.6506 11.4104C16.7411 11.4104 18.4358 9.7157 18.4358 7.62517C18.4358 5.53464 16.7411 3.83993 14.6506 3.83993C14.1437 3.83993 13.6601 3.93957 13.2182 4.12033Z"
				/>
			</mask>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.3986 10.1138C14.1217 9.35849 14.5659 8.33403 14.5659 7.20582C14.5659 6.37192 14.3232 5.59471 13.9046 4.94095C14.1421 4.87511 14.3922 4.83993 14.6506 4.83993C16.1889 4.83993 17.4358 6.08692 17.4358 7.62517C17.4358 9.16341 16.1889 10.4104 14.6506 10.4104C14.2003 10.4104 13.775 10.3036 13.3986 10.1138ZM13.2182 4.12033C12.468 3.42503 11.4637 3 10.3601 3C8.03731 3 6.1543 4.88301 6.1543 7.20582C6.1543 9.52863 8.03731 11.4116 10.3601 11.4116C11.1698 11.4116 11.9261 11.1828 12.5678 10.7863C13.1652 11.1808 13.8811 11.4104 14.6506 11.4104C16.7411 11.4104 18.4358 9.7157 18.4358 7.62517C18.4358 5.53464 16.7411 3.83993 14.6506 3.83993C14.1437 3.83993 13.6601 3.93957 13.2182 4.12033Z"
				fill={fillColor}
			/>
			<path
				d="M13.3986 10.1138L12.6763 9.4223L11.7417 10.3985L12.9485 11.0068L13.3986 10.1138ZM13.9046 4.94095L13.6374 3.97732L12.332 4.33933L13.0625 5.48019L13.9046 4.94095ZM13.2182 4.12033L12.5385 4.85379L13.0064 5.28744L13.5969 5.04587L13.2182 4.12033ZM12.5678 10.7863L13.1187 9.95181L12.5856 9.59982L12.0421 9.93563L12.5678 10.7863ZM13.5659 7.20582C13.5659 8.0662 13.2283 8.84563 12.6763 9.4223L14.121 10.8053C15.0151 9.87136 15.5659 8.60186 15.5659 7.20582H13.5659ZM13.0625 5.48019C13.3811 5.97779 13.5659 6.56869 13.5659 7.20582H15.5659C15.5659 6.17515 15.2654 5.21163 14.7468 4.40172L13.0625 5.48019ZM14.6506 3.83993C14.3011 3.83993 13.961 3.88758 13.6374 3.97732L14.1719 5.90459C14.3231 5.86265 14.4834 5.83993 14.6506 5.83993V3.83993ZM18.4358 7.62517C18.4358 5.53464 16.7411 3.83993 14.6506 3.83993V5.83993C15.6366 5.83993 16.4358 6.63921 16.4358 7.62517H18.4358ZM14.6506 11.4104C16.7411 11.4104 18.4358 9.7157 18.4358 7.62517H16.4358C16.4358 8.61113 15.6366 9.4104 14.6506 9.4104V11.4104ZM12.9485 11.0068C13.4613 11.2653 14.0405 11.4104 14.6506 11.4104V9.4104C14.3602 9.4104 14.0887 9.34182 13.8487 9.22086L12.9485 11.0068ZM10.3601 4C11.2018 4 11.9658 4.32306 12.5385 4.85379L13.898 3.38687C12.9701 2.527 11.7255 2 10.3601 2V4ZM7.1543 7.20582C7.1543 5.43529 8.58959 4 10.3601 4V2C7.48502 2 5.1543 4.33072 5.1543 7.20582H7.1543ZM10.3601 10.4116C8.58959 10.4116 7.1543 8.97634 7.1543 7.20582H5.1543C5.1543 10.0809 7.48502 12.4116 10.3601 12.4116V10.4116ZM12.0421 9.93563C11.5538 10.2373 10.9789 10.4116 10.3601 10.4116V12.4116C11.3608 12.4116 12.2983 12.1283 13.0934 11.637L12.0421 9.93563ZM12.0168 11.6209C12.7727 12.1199 13.6793 12.4104 14.6506 12.4104V10.4104C14.083 10.4104 13.5578 10.2417 13.1187 9.95181L12.0168 11.6209ZM14.6506 12.4104C17.2934 12.4104 19.4358 10.268 19.4358 7.62517H17.4358C17.4358 9.16341 16.1889 10.4104 14.6506 10.4104V12.4104ZM19.4358 7.62517C19.4358 4.98235 17.2934 2.83993 14.6506 2.83993V4.83993C16.1889 4.83993 17.4358 6.08692 17.4358 7.62517H19.4358ZM14.6506 2.83993C14.0116 2.83993 13.3995 2.96571 12.8396 3.19479L13.5969 5.04587C13.9206 4.91343 14.2758 4.83993 14.6506 4.83993V2.83993Z"
				fill={strokeColor}
				mask="url(#path-2-inside-1_1902_6245)"
			/>
			<path
				d="M3.38383 17.4152C4.13817 14.4228 7.06874 12.6719 10.1547 12.6719H10.5656C13.6516 12.6719 16.5822 14.4228 17.3365 17.4152C17.474 17.9606 17.5855 18.5095 17.6522 19.0357C17.7217 19.5836 17.2726 20.0321 16.7204 20.0321H4C3.44771 20.0321 2.99866 19.5836 3.06812 19.0357C3.13483 18.5095 3.24634 17.9606 3.38383 17.4152Z"
				fill={fillColor}
				stroke={strokeColor}
				strokeLinecap="round"
			/>
		</svg>
	);
}
function SidebarInfoIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="10" cy="10" r="7" stroke="#5D5D5D" />
			<path
				d="M9.99967 6.76732C10.285 6.76732 10.5163 6.536 10.5163 6.25065C10.5163 5.9653 10.285 5.73398 9.99967 5.73398C9.71433 5.73398 9.48301 5.9653 9.48301 6.25065C9.48301 6.536 9.71433 6.76732 9.99967 6.76732Z"
				fill="#5D5D5D"
				stroke="#5D5D5D"
				stroke-width="0.2"
			/>
			<path d="M10 14.1673V8.33398" stroke="#5D5D5D" stroke-width="1.2" />
		</svg>
	);
}

export {
	SidebarOrderIcon,
	SidebarProfileIcon,
	SidebarSignoutIcon,
	SidebarRosterIcon,
	SidebarInfoIcon,
};
